/* eslint-disable max-len */
import {
  TYPE_NAME,
  CATEGORY_NAME,
  FUEL_NAME,
  ATTRIBUTE_NAMES,
  TYPE_REG_EXP,
  CATEGORY_REG_EXP,
  SUPERDUPERSKU_NAMES,
  SEARCH_LABEL_NAME,
  SPEC_TITLE,
  HEADER_NAME_APPLIANCE_TYPE,
  HEADER_NAME_FUEL_TYPE
} from './constants';

const regExpReducer = (typeCategoryPairs = []) => {
  return (typeof typeCategoryPairs === 'string' ? [typeCategoryPairs] : typeCategoryPairs)?.reduce((acc, curr) => {
    const typeMatches = curr?.match(TYPE_REG_EXP) ?? [];
    typeMatches.forEach(type => {
      if (type && !acc.types.includes(type)) {
        acc.types.push(type);
      }
    });

    const categoryMatches = curr?.match(CATEGORY_REG_EXP) ?? [];
    categoryMatches.forEach((category) => {
      if (category && !acc.categories.includes(category)) {
        acc.categories.push(category);
      }
    });

    return acc;
  }, { types: [], categories: [] });
};

const specificationsSearch = (specifications, specName) => {
  return specifications?.find(({ specName: name }) => name === specName)?.specValue?.toLowerCase();
};

export const getProductSpecificationData = (product) => {
  const specifications = product?.specificationGroup?.find(({ specTitle }) => specTitle === SPEC_TITLE)?.specifications;
  const { types: productTypes, categories: productCategories } = regExpReducer(
    (specificationsSearch(specifications, TYPE_NAME)
      ?? specificationsSearch(specifications, CATEGORY_NAME))) || {};
  const fuelType = (regExpReducer(
    (specificationsSearch(specifications, FUEL_NAME)
      ?? specificationsSearch(specifications, TYPE_NAME))) || {})?.types[0];

  return {
    productTypes,
    productCategories,
    fuelType
  };
};

const attributeSearch = (attributes, attributeMatch) => {
  return attributes?.reduce((acc, { attributeValues, attributeName }) => {
    if (attributeMatch.includes(attributeName)) {
      return attributeValues.map(({ value }) => value?.toLowerCase());
    }
    return acc;
  }, null);
};

export const getMetadataAttributeData = (metadata) => {
  const { attributes, superDuperSku } = metadata || {};
  const { types: metadataTypes, categories: metadataCategories } = regExpReducer(
    (attributeSearch(attributes, ATTRIBUTE_NAMES)
      ?? attributeSearch(superDuperSku?.attributes, SUPERDUPERSKU_NAMES))) || {};

  const selectedType = (attributes ?? superDuperSku?.attributes)?.reduce((acc, { attributeValues, attributeName }) => {
    if (ATTRIBUTE_NAMES.includes(attributeName) || SUPERDUPERSKU_NAMES.includes(attributeName)) {
      const selectedAttribute = attributeValues?.find(({ selected }) => selected === true);
      if (selectedAttribute?.value) {
        const { types } = regExpReducer([selectedAttribute.value]) || {};
        return types[0] || acc;
      }
    }
    return acc;
  }, null);

  return {
    metadataTypes,
    metadataCategories,
    selectedType
  };
};

const filterSearch = (filters) => {
  return filters?.find(({ label }) => label === SEARCH_LABEL_NAME)?.refinements?.map(({ label }) => label?.toLowerCase());
};

export const getSearchModelFilterData = (search) => {
  const { dimensions, primaryFilters } = search;

  const { types: filterTypes, categories: filterCategories } = regExpReducer(
    (filterSearch(dimensions) ?? filterSearch(primaryFilters))) || {};

  return {
    filterTypes,
    filterCategories
  };
};

export const track = ({ eventType }) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.top.LIFE_CYCLE_EVENT_BUS.trigger(`appliance-fuel-type-drawer.${eventType}`);
  }
};

export const buildHeader = ({
  allowHeader = true,
  isDryer = false,
  metadataTypes,
  fuelType,
  selectedType
}) => {
  const canBuildHeader = (allowHeader && !metadataTypes.length && (!!fuelType || !!selectedType));
  const header = canBuildHeader ? (fuelType ?? selectedType).split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ') : '';

  const shouldShowHeader = !!header;
  const headerName = isDryer ? HEADER_NAME_APPLIANCE_TYPE : HEADER_NAME_FUEL_TYPE;
  const headerLabel = isDryer ? `${header} Dryer` : header;

  return {
    shouldShowHeader,
    headerName,
    headerLabel
  };
};
